module.exports = __webpack_public_path__ + "static/media/CTLA_8-216w.f39c3dc7.jpg";